module.exports = __webpack_public_path__ + "b2b075bbc87ac325cc3a94c4de456fd9.svg";